import sassVars from '@scss/_exports.scss';

const screenSmMin = window.matchMedia(`(min-width: ${sassVars.screenSmMin})`);
const screenSmMax = window.matchMedia(`(max-width: ${sassVars.screenSmMax})`);
const screenMdMin = window.matchMedia(`(min-width: ${sassVars.screenMdMin})`);
const screenMdMax = window.matchMedia(`(max-width: ${sassVars.screenMdMax})`);
const screenLgMin = window.matchMedia(`(min-width: ${sassVars.screenLgMin})`);
const screenLgMax = window.matchMedia(`(max-width: ${sassVars.screenLgMax})`);
const screenXlMin = window.matchMedia(`(min-width: ${sassVars.screenXlMin})`);
const screenXlMax = window.matchMedia(`(max-width: ${sassVars.screenXlMax})`);

export {
    screenSmMin,
    screenSmMax,
    screenMdMin,
    screenMdMax,
    screenLgMin,
    screenLgMax,
    screenXlMin,
    screenXlMax
};
